import { css } from 'styled-components';

export const placeholderTextStyle = css`
    font-style: italic;
`;
